import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Card from "react-bootstrap/Card";
import ListGroup from "react-bootstrap/ListGroup";
import Sidebar from "./components/sidebar";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Badge from "react-bootstrap/Badge";
import axios from "axios";

const ModuleVideos = () => {
  const { cursoId } = useParams();
  const [modulos, setModulos] = useState([]);
  const [lecciones, setLecciones] = useState([]);
  const [curso, setCurso] = useState(null);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [selectedModulo, setSelectedModulo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModulos, setShowModulos] = useState(true);
  
  // Estados para comentarios
  const [comentarios, setComentarios] = useState([]);
  const [nuevoComentario, setNuevoComentario] = useState({
    nombre: '',
    email: '',
    comentario: ''
  });
  const [enviandoComentario, setEnviandoComentario] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Obtener información del curso
        const cursoResponse = await axios.get(
          `https://api.mrcirp.com/public/cursos/${cursoId}`
        );
        setCurso(cursoResponse.data[0]);

        // Obtener módulos del curso filtrados por idcurso
        const modulosResponse = await axios.get(
          `https://api.mrcirp.com/public/modulos`
        );
        // Filtrar los módulos por el idcurso correspondiente
        const modulosFiltrados = modulosResponse.data.filter(
          (modulo) => modulo.idcurso == cursoId
        );
        setModulos(modulosFiltrados);

        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchData();
  }, [cursoId]);

  // Cargar comentarios cuando cambie el video seleccionado o cuando se cargue el módulo
  useEffect(() => {
    if (selectedVideo) {
      cargarComentarios();
    } else if (cursoId) {
      // Si no hay video seleccionado pero hay un cursoId, cargar comentarios del módulo
      cargarComentariosModulo();
    }
  }, [selectedVideo, cursoId]);

  const fetchLeccionesByModulo = async (moduloId) => {
    try {
      setLoading(true);
      const leccionesResponse = await axios.get(
        `https://api.mrcirp.com/public/leccionescursos/${cursoId}`
      );
      // Filtrar lecciones por el módulo correspondiente
      const leccionesFiltradas = leccionesResponse.data.filter(
        (leccion) => leccion.modulo == moduloId
      );
      setLecciones(leccionesFiltradas);

      // Establecer la primera lección como seleccionada por defecto si hay lecciones
      if (leccionesFiltradas.length > 0) {
        setSelectedVideo(leccionesFiltradas[0]);
      } else {
        setSelectedVideo(null);
      }

      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const handleModuloClick = (modulo) => {
    setSelectedModulo(modulo);
    fetchLeccionesByModulo(modulo.id);
    setShowModulos(false);
  };

  const handleBackToModulos = () => {
    setShowModulos(true);
    setSelectedModulo(null);
    setLecciones([]);
    setSelectedVideo(null);
  };

  function extractYouTubeId(url) {
    const regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  }

  // Funciones para manejar comentarios
  const cargarComentarios = async () => {
    if (!selectedVideo?.id) return;
    
    try {
      const response = await axios.get(`https://api.mrcirp.com/public/comentarios-modulos/modulo/${selectedVideo.id}`);
      setComentarios(response.data);
    } catch (err) {
      console.error('Error al cargar comentarios:', err);
      // En caso de error, usar comentarios simulados como fallback
      const comentariosSimulados = [
        {
          id: 1,
          usuario_nombre: 'María González',
          usuario_email: 'maria@ejemplo.com',
          comentario: 'Excelente lección, muy clara y bien explicada. Me ayudó mucho a entender el concepto.',
          fecha_creacion: '2024-01-15',
          modulo_id: selectedVideo?.id
        },
        {
          id: 2,
          usuario_nombre: 'Carlos Rodríguez',
          usuario_email: 'carlos@ejemplo.com',
          comentario: 'Muy buen contenido, pero me gustaría que profundicen más en el tema de las prácticas.',
          fecha_creacion: '2024-01-14',
          modulo_id: selectedVideo?.id
        }
      ];
      setComentarios(comentariosSimulados);
    }
  };

  const cargarComentariosModulo = async () => {
    if (!cursoId) return;
    
    try {
      const response = await axios.get(`https://api.mrcirp.com/public/comentarios-modulos/modulo/${cursoId}`);
      setComentarios(response.data);
    } catch (err) {
      console.error('Error al cargar comentarios del módulo:', err);
      setComentarios([]);
    }
  };

  const handleEnviarComentario = async (e) => {
    e.preventDefault();
    if (!nuevoComentario.nombre || !nuevoComentario.comentario) {
      alert('Por favor completa todos los campos obligatorios');
      return;
    }

    // Usar el ID del módulo (cursoId) o del video seleccionado
    const moduloId = selectedVideo?.id || cursoId;
    
    if (!moduloId) {
      alert('No se pudo determinar el módulo para el comentario');
      return;
    }

    setEnviandoComentario(true);
    try {
      // Obtener información del usuario logueado
      const loginUserJSON = window.localStorage.getItem("loginUser");
      const loggedInUser = loginUserJSON ? JSON.parse(loginUserJSON) : null;

      const comentarioData = {
        modulo_id: moduloId,
        usuario_id: loggedInUser?.id || 0, // Usar ID del usuario logueado o 0 para anónimos
        usuario_nombre: nuevoComentario.nombre,
        usuario_email: nuevoComentario.email || '',
        comentario: nuevoComentario.comentario
      };

      const response = await axios.post('https://api.mrcirp.com/public/comentarios-modulos', comentarioData);
      
      if (response.data.success) {
        // Recargar comentarios después de crear uno nuevo
        if (selectedVideo) {
          await cargarComentarios();
        } else {
          await cargarComentariosModulo();
        }
        
        setNuevoComentario({ nombre: '', email: '', comentario: '' });
        alert('¡Comentario enviado exitosamente!');
      } else {
        throw new Error(response.data.message || 'Error al enviar comentario');
      }
    } catch (err) {
      console.error('Error al enviar comentario:', err);
      alert('Error al enviar el comentario. Inténtalo de nuevo.');
    } finally {
      setEnviandoComentario(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNuevoComentario(prev => ({
      ...prev,
      [name]: value
    }));
  };

  if (loading) {
    return (
      <Sidebar>
        <Container className="mt-4">
          <Card>
            <Card.Body className="text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Cargando...</span>
              </div>
              <p className="mt-2">Cargando contenido del curso...</p>
            </Card.Body>
          </Card>
        </Container>
      </Sidebar>
    );
  }

  if (error) {
    return (
      <Sidebar>
        <Container className="mt-4">
          <Card>
            <Card.Body className="text-center">
              <div className="alert alert-danger">
                Error al cargar el curso: {error}
              </div>
              <Button
                variant="primary"
                onClick={() => window.location.reload()}
              >
                Intentar nuevamente
              </Button>
            </Card.Body>
          </Card>
        </Container>
      </Sidebar>
    );
  }

  if (!curso) {
    return (
      <Sidebar>
        <Container className="mt-4">
          <Card>
            <Card.Body>
              <Card.Title>Curso no encontrado</Card.Title>
              <Card.Text>El curso solicitado no existe.</Card.Text>
            </Card.Body>
          </Card>
        </Container>
      </Sidebar>
    );
  }

  if (showModulos) {
    return (
      <Sidebar>
        <Container className="mt-4">
          <Card className="mb-4">
            <Card.Header as="h4">{curso.nombrecurso}</Card.Header>
            <Card.Body>
              <Card.Title>Módulos del curso</Card.Title>
              <Row>
                {modulos.length > 0 ? (
                  modulos.map((modulo) => (
                    <Col key={modulo.id} md={6} className="mb-4">
                      <Card
                        className="h-100 cursor-pointer"
                        onClick={() => handleModuloClick(modulo)}
                        style={{ cursor: "pointer" }}
                      >
                        <Card.Body>
                          <Card.Title>{modulo.nombremodulo}</Card.Title>
                          <Card.Text>{modulo.descripcionmodulo}</Card.Text>
                        </Card.Body>
                        
                        <Card.Footer
                          className="text-primary"
                          style={{ cursor: "pointer" }}
                        >
                          Haz clic para ver las lecciones
                        </Card.Footer>
                      </Card>
                    </Col>
                  ))
                ) : (
                  <Col>
                    <p className="text-muted">
                      No hay módulos disponibles para este curso
                    </p>
                  </Col>
                )}
              </Row>
            </Card.Body>
          </Card>
        </Container>
      </Sidebar>
    );
  }

  return (
    <Sidebar>
      <Container className="mt-4">
        <Button
          variant="outline-secondary"
          className="mb-3"
          onClick={handleBackToModulos}
        >
          &larr; Volver a módulos
        </Button>

        <Row>
          <Col lg={8}>
            <Card className="mb-4">
              <Card.Header as="h4">
                {selectedModulo?.nombremodulo || "Módulo no seleccionado"}
              </Card.Header>
              <Card.Body>
                {/* Reproductor de video */}
                {selectedVideo ? (
                  <>
                    <div className="ratio ratio-16x9 mb-4">
                      <iframe
                        src={`https://www.youtube.com/embed/${extractYouTubeId(
                          selectedVideo.urlvideo
                        )}?autoplay=1`}
                        title={selectedVideo.nombreleccion}
                        allowFullScreen
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      ></iframe>
                    </div>

                    <Card.Title>{selectedVideo.nombreleccion}</Card.Title>
                    <Card.Text>{selectedVideo.descripcion_leccion}</Card.Text>
                  </>
                ) : (
                  <div className="text-center py-4">
                    <p>No hay videos disponibles para este módulo</p>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>

          <Col lg={4}>
            <Card>
              <Card.Header as="h5">Lista de lecciones</Card.Header>
              {lecciones.length > 0 ? (
                <ListGroup variant="flush">
                  {lecciones.map((leccion) => (
                    <ListGroup.Item
                      key={leccion.id}
                      action
                      active={selectedVideo?.id === leccion.id}
                      onClick={() => setSelectedVideo(leccion)}
                      className="d-flex justify-content-between align-items-start"
                    >
                      <div className="ms-2 me-auto">
                        <div className="fw-bold">{leccion.nombreleccion}</div>
                        {leccion.descripcion_corta}
                      </div>
                      <span className="badge bg-primary rounded-pill">
                        {leccion.duracion}
                      </span>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              ) : (
                <Card.Body>
                  <p className="text-muted">
                    No hay lecciones disponibles en este módulo
                  </p>
                </Card.Body>
              )}

              {curso.material_url && (
                <Card.Footer className="text-center">
                  <Button
                    variant="primary"
                    size="sm"
                    href={curso.materiales}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar material
                  </Button>
                </Card.Footer>
              )}
            </Card>
          </Col>
        </Row>

        {/* Sección de recursos adicionales */}
        <Row className="mt-4">
          <Col>
            <Card>
              <Card.Header as="h5">Recursos adicionales</Card.Header>
              <Card.Body>
                <Row>
                  <Col md={6}>
                    <Card className="h-100">
                      <Card.Body>
                        <Card.Title>Documentación PDF</Card.Title>
                        <Card.Text>
                          Guía completa del curso en formato PDF
                        </Card.Text>
                        <Button
                          variant="outline-primary"
                          size="sm"
                          href={curso.materiales || "#"}
                          target="_blank"
                          disabled={!curso.materiales}
                        >
                          {curso.materiales ? "Descargar" : "No disponible"}
                        </Button>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={6}>
                    <Card className="h-100">
                      <Card.Body>
                        <Card.Title>Ejercicios prácticos</Card.Title>
                        <Card.Text>
                          Ejercicios para practicar lo aprendido
                        </Card.Text>
                        <Button
                          variant="outline-primary"
                          size="sm"
                          href={curso.ejercicios || "#"}
                          target="_blank"
                          disabled={!curso.ejercicios}
                        >
                          {curso.ejercicios ? "Descargar" : "No disponible"}
                        </Button>
                      </Card.Body>
                    </Card>
                  </Col>
                  
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Sección de comentarios */}
        <Row className="mt-4">
          <Col>
            <Card>
              <Card.Header as="h5" className="d-flex justify-content-between align-items-center">
                <span>
                  💬 Comentarios sobre {selectedVideo ? `"${selectedVideo.nombreleccion}"` : `Módulo ${cursoId}`}
                </span>
                <Badge bg="primary">{comentarios.length} comentarios</Badge>
              </Card.Header>
                <Card.Body>
                  {/* Formulario para nuevo comentario */}
                  <Card className="mb-4">
                    <Card.Header as="h6">Deja tu comentario</Card.Header>
                    <Card.Body>
                      <Form onSubmit={handleEnviarComentario}>
                        <Row>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Nombre *</Form.Label>
                              <Form.Control
                                type="text"
                                name="nombre"
                                value={nuevoComentario.nombre}
                                onChange={handleInputChange}
                                placeholder="Tu nombre"
                                required
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Email (opcional)</Form.Label>
                              <Form.Control
                                type="email"
                                name="email"
                                value={nuevoComentario.email}
                                onChange={handleInputChange}
                                placeholder="tu@email.com"
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                        <Form.Group className="mb-3">
                          <Form.Label>Comentario *</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={4}
                            name="comentario"
                            value={nuevoComentario.comentario}
                            onChange={handleInputChange}
                            placeholder="Comparte tu opinión sobre esta lección..."
                            required
                          />
                        </Form.Group>
                        <Button 
                          type="submit" 
                          variant="primary"
                          disabled={enviandoComentario}
                        >
                          {enviandoComentario ? 'Enviando...' : 'Enviar Comentario'}
                        </Button>
                      </Form>
                    </Card.Body>
                  </Card>

                  {/* Lista de comentarios */}
                  {comentarios.length > 0 ? (
                    <div className="comentarios-lista">
                      {comentarios.map((comentario) => (
                        <Card key={comentario.id} className="mb-3">
                          <Card.Body>
                            <div className="d-flex justify-content-between align-items-start mb-2">
                              <div>
                                <h6 className="mb-1 text-primary">{comentario.usuario_nombre}</h6>
                                <small className="text-muted">
                                  {new Date(comentario.fecha_creacion).toLocaleDateString('es-ES', {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric'
                                  })}
                                </small>
                              </div>
                              <div>
                                <Badge bg="light" text="dark">
                                  #{comentario.id}
                                </Badge>
                                {!comentario.moderado && (
                                  <Badge bg="warning" text="dark" className="ms-1">
                                    Pendiente
                                  </Badge>
                                )}
                                {comentario.moderado && comentario.activo && (
                                  <Badge bg="success" className="ms-1">
                                    Aprobado
                                  </Badge>
                                )}
                              </div>
                            </div>
                            <p className="mb-0">{comentario.comentario}</p>
                            
                            {/* Respuesta del administrador */}
                            {comentario.respuesta_admin && (
                              <div className="mt-3 p-3 bg-light rounded">
                                <h6 className="text-primary mb-2">Respuesta del administrador:</h6>
                                <p className="mb-1">{comentario.respuesta_admin}</p>
                                {comentario.fecha_respuesta && (
                                  <small className="text-muted">
                                    - {comentario.admin_nombre} • {new Date(comentario.fecha_respuesta).toLocaleDateString('es-ES')}
                                  </small>
                                )}
                              </div>
                            )}
                          </Card.Body>
                        </Card>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-4">
                      <p className="text-muted">
                        No hay comentarios aún. ¡Sé el primero en comentar!
                      </p>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
      </Container>
    </Sidebar>
  );
};

export default ModuleVideos;
